import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function CoffeeIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M15 6.66699h.8333c.8841 0 1.7319.35119 2.3571.97631.6251.62512.9763 1.47297.9763 2.357 0 .8841-.3512 1.7319-.9763 2.357-.6252.6252-1.473.9764-2.3571.9764H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66675 6.66699H15.0001V14.167c0 .884-.3512 1.7319-.9763 2.357-.6252.6251-1.473.9763-2.3571.9763H5.00008c-.88405 0-1.7319-.3512-2.35702-.9763-.62512-.6251-.97631-1.473-.97631-2.357V6.66699ZM5 .833008V3.33301M8.33325.833008V3.33301M11.6667.833008V3.33301"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
